<template>
  <transition name="fade" mode="out-in">
    <div v-if="message && !dismissed" class="form-alert" :class="{ 'form-alert--flush': flush }" role="alert">
      <div
        :class="`alert alert-${type} mb-0`"
        class="form-alert__body alert-pop"
        title="Click to dismiss"
        @click="dismiss"
      >{{ message }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FormAlert',
  props: {
    message: { type: String, default: null },
    type: { type: String, default: 'warning' },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: { type: Boolean, default: false },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: { type: Boolean, default: false }
  },
  data() {
    return { dismissed: false }
  },
  mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert()
  },
  watch: {
    message(val) {
      this.dismissed = false
      if (val) this.scrollToAlert()
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss() {
      this.dismissed = true
      this.$emit('dismiss')
    },
    scrollToAlert() {
      this.$nextTick(() => {
        if (this.$el) {
          this.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      })
    }
  }
}
</script>

<style scoped>
.form-alert {
  padding: 0.75rem 0;
}

.form-alert--flush {
  padding: 0;
}

.form-alert__body {
  cursor: pointer;
}

/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)
   so they render one per line instead of a run-on sentence. */
.form-alert__body {
  white-space: pre-line;
  text-align: left;
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FormAlert.vue